// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createContainer, createHook, createStore } from '@atlassian/react-sweet-state';
import { actions } from './actions.tsx';
import { selectChangeboarding, selectOnboardingTour } from './selectors.tsx';
import type { State } from './types.tsx';
import { rehydrate } from './utils.tsx';

const initialState: State = {
	_rehydrated: false,
};

const store = createStore<State, typeof actions>({
	initialState,
	actions,
	name: 'portfolio-3/onboarding',
});

export const useRehydrated = createHook(store, {
	selector: (state) => state._rehydrated,
});

export const useChangeboarding = createHook(store, {
	selector: selectChangeboarding,
});

export const useOnboardingTour = createHook(store, {
	selector: selectOnboardingTour,
});

export const OnboardingProvider = createContainer(store, {
	onInit:
		() =>
		async ({ setState, getState, dispatch }) => {
			if (getState()._rehydratePromise === undefined) {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				const promise = dispatch(rehydrate)!;
				setState({ _rehydratePromise: promise });
				await promise;
			}
		},
});
